export default "__VITE_ASSET__BMY9P9Cf__"